export class LocationModel{
  latitude:string;
  longitude:string;

  constructor(latitude:string,longitude:string){
    this.latitude = latitude;
    this.longitude = longitude;
  }
}



// WEBPACK FOOTER //
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/models/location.model.ts